import {useCallback, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {BottomSheet} from '~library/molecules/BottomSheet';
import {ResponsiveModal} from '~library/organisms/ResponsiveModal';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {OverlayContent} from '~/SignUpSheets/Create/routes/Customize/components/AddMultipleSlots/OverlayContent';
import {UPDATE_MULTIPLE_SLOTS_MODAL_CLEAR_FORM} from '~/SignUpSheets/reducers/sheet/constants';
import {mediumAndUpQuery} from '~libSass/base/_exports.sass';
import './AddMultipleSlots.sass';

export const AddMultipleSlots = ({onClose, onSubmit}) => {
  const dispatch = useDispatch();
  const {matches: isDesktop} = useMatchQuery(`(${mediumAndUpQuery})`);

  const handleOnClose = useCallback(() => {
    dispatch({type: UPDATE_MULTIPLE_SLOTS_MODAL_CLEAR_FORM});
    onClose();
  }, [dispatch, onClose]);

  useEffect(() => {
    document.body.classList.add('no-overflow');

    return () => {
      document.body.classList.remove('no-overflow');
    };
  }, []);

  return isDesktop ? (
    <ResponsiveModal
      modalId="add-multiple-slots__modal"
      title="Adding multiple time slots"
      isOpen
      onClose={handleOnClose}
      closeOnClickOutside={false}
    >
      <OverlayContent onClose={handleOnClose} onSubmit={onSubmit} />
    </ResponsiveModal>
  ) : (
    <BottomSheet
      in
      title="Adding multiple time slots"
      data-qa-id="add-multiple-slots__bottom-sheet"
      content={<OverlayContent onClose={handleOnClose} onSubmit={onSubmit} />}
      onClose={handleOnClose}
    />
  );
};
